// extracted by mini-css-extract-plugin
export var contentBody = "_bo-9";
export var headerImage = "_bo-2";
export var imageButton = "_bo-7";
export var imageButtonIcon = "_bo-8";
export var imageHeader = "_bo-4";
export var imageHeaderText = "_bo-5";
export var imageOverlay = "_bo-3";
export var imageTitle = "_bo-6";
export var imageWrapper = "_bo-1";
export var taskList = "_bo-a";
export var widget = "_bo-0";